var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('h6',{staticClass:"navbar-heading p-0 ml-4 text-muted"},[_vm._v("Панель")]),_c('sidebar-item',{attrs:{"link":{
          name: 'Статистика',
          path: '/dashboard',
          icon: 'ni ni-tv-2',
        }}}),_c('h6',{staticClass:"navbar-heading p-0 ml-4 text-muted mt-2"},[_vm._v("Транзакции")]),_c('sidebar-item',{attrs:{"link":{
            name: 'Переводы P2P',
            path: '/s-transfers',
            icon: 'ni ni-bold-up'
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: 'Получение',
              path: '/r-transfers',
              icon: 'ni ni-bold-down'
            }}}),_c('h6',{staticClass:"navbar-heading p-0 ml-4 text-muted mt-2"},[_vm._v("Настройки")]),_c('sidebar-item',{attrs:{"link":{
                  name: 'Карты',
                  path: '/cards',
                  icon: 'ni ni-credit-card'
                }}}),_c('sidebar-item',{attrs:{"link":{
                  name: 'Настройки',
                  path: '/settings',
                  icon: 'ni ni-settings-gear-65'
                }}}),_c('h6',{staticClass:"navbar-heading p-0 ml-4 text-muted mt-2"},[_vm._v("Провайдеры")]),_c('sidebar-item',{attrs:{"link":{
                  name: 'Провайдеры',
                  path: '/providers',
                  icon: 'ni ni-vector'
                }}})],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }